import React, {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from 'react';
import { Button, Modal, Popconfirm, Space } from 'antd';
import { Checkbox, Form, Input } from 'antd';
import { Delete } from '@icon-park/react';
import {IconCloseBlack} from "@/Icon";
import {t} from "i18next";
import './link.css'
import {MAX_Z_INDEX} from "@/Const";
import global from "@/global";


let Res:any;
const LinkPage = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowLink:showModal
    }))
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [submittable, setSubmittable] = React.useState<boolean>(false);

    const [form] = Form.useForm();
    const formRef = useRef(null);
    const txtTitleRef = useRef(null);

    const showModal = (link:any,onCallback:any) => {
        Res = onCallback;
        setIsModalOpen(true);

        if (link) {
            setIsEdit(true)
            form.setFieldsValue({ link: link.link, text: link.text })
        }

        setTimeout(()=>{
            txtTitleRef.current?.focus();
        },100)
    };

    const handleCancel = () => {
        Res(false)
        setIsModalOpen(false);
    };

    const onFinish = (values: any) => {
        console.log('Success:', values);
        Res(values)
        setIsModalOpen(false);
        //重置数据
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const doDelete = () => {
        Res({ delete: true })
        setIsModalOpen(false);
    }

    type FieldType = {
        text?: string;
        link?: string;
    };

    const values = Form.useWatch([], form);

    useEffect(() => {
        // @ts-ignore
        // window.GGetLink = (param: any) => {
        //     console.log('param: ', param);
        //     return new Promise(res => {
        //         Res = res
        //         setIsModalOpen(true);
        //         setIsEdit(false)
        //         form.resetFields()
        //         if (param) {
        //             setIsEdit(true)
        //             form.setFieldsValue({ link: param.link, text: param.text })
        //         }
        //     })
        // }
    }, [])

    useEffect(() => {
        form
            .validateFields({ validateOnly: true })
            .then(() => setSubmittable(true))
            .catch(() => setSubmittable(false));
    }, [form, values]);

    useLayoutEffect(()=>{
        return ()=>{
            formRef.current?.resetFields();
        }
    })

    return (
        <>
            <Modal title="" zIndex={MAX_Z_INDEX} closeIcon={<IconCloseBlack/>}
                   bodyStyle={{zIndex:'1003'}}
                   open={isModalOpen}
                   onCancel={handleCancel}
                   destroyOnClose={true}
                   afterClose={()=>{
                       formRef.current?.resetFields();
                   }}
                   afterOpenChange={(e)=>{
                       global.g_showDialogs.dialogInfos = e;
                   }}
                   centered={true} footer={null} width={'428px'}>
                <Form
                    ref={formRef}
                    name="basic"
                    layout="vertical"
                    style={{ marginBottom:'-20px'}}
                    className='modaaaaal'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                >
                    {
                        <Form.Item<FieldType>
                            label={t("Text")}
                            name="text"
                            className='font-family-medium'
                            rules={[{ required: true, message: '' }]}
                        >
                            <Input ref={txtTitleRef} variant={"borderless"} style={{color:'var(--text-color)',paddingLeft:'12px'}} className={'input-border'} disabled={isEdit} />
                        </Form.Item>

                    }

                    <Form.Item<FieldType>
                        label={t("Enter a link")}
                        name="link"
                        rules={[{ required: true, message: '' }, {
                            message: '',
                            // pattern: /^https?:\/\//
                        }]}
                    >
                        <Input variant={"borderless"} style={{color:'var(--text-color)',paddingLeft:'12px'}} className={'input-border'}/>
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                        <div className='flex-center' style={{width:'100%'}}>
                            {/*<Popconfirm*/}
                            {/*    title={t("Confirm to remove the link?")}*/}
                            {/*    onConfirm={doDelete}*/}
                            {/*    onCancel={() => onFinish(false)}*/}
                            {/*    okText={t("Remove")}*/}
                            {/*    cancelText={t("Cancel")}*/}
                            {/*>*/}
                            {/*    */}
                            {/*</Popconfirm>*/}
                            <Button style={{minWidth:'164px',height:'38px',background:'transparent'}} className='button-border-gray-style font-family-medium' onClick={doDelete}>{t("Delete")}</Button>

                            <button disabled={!submittable} style={{minWidth:'164px',height:'38px',marginLeft:'12px'}} className='button-solid-style font-family-medium flex-center' type="submit">
                                {t('Done')}
                            </button>
                        </div>
                    </Form.Item>
                </Form>


            </Modal>
        </>
    );
})

export default LinkPage;
